module.exports = __webpack_public_path__ + "static/img/IDaaS-icon-4.a2f08487.svg";